import { AppState } from "react-native";

class ActiveTimeCost {
    constructor() {
        this._time_slices = [];
        this._stateInitialized = AppState.currentState;
        this._handleAppStateChange = this._handleAppStateChange.bind(this);
        AppState.addEventListener("change", this._handleAppStateChange);
        this.resume();
    }

    _handleAppStateChange(nextAppState) {
        if (this._stateInitialized !== nextAppState) {
            this._stateInitialized = nextAppState;

            if ("active" === nextAppState) {
                if (!this._paused) {
                    if (!this._current_time) {
                        var now = new Date();
                        this._current_time = now;
                    }
                }
            }
            else {
                if (this._current_time) {
                    this._pushTimeSlice();
                    delete this._current_time;
                }
            }
        }
    }

    _pushTimeSlice() {
        if (this._current_time) {
            var now = new Date();
            var ms = now - this._current_time;
            if (ms > 100) {
                this._time_slices.push(ms);
            }
        }
    }

    pause() {
        this._paused = true;
        if (this._current_time) {
            this._pushTimeSlice();
            delete this._current_time;
        }
    }

    resume() {
        if ("active" === this._stateInitialized) {
            if (!this._current_time) {
                this._current_time = new Date();
            }
        }
        this._paused = false;
    }

    timeCost() {
        var r = this._time_slices.reduce((prev,cur) => {
            return prev + cur;
        }, 0);

        if (this._current_time) {
            var now = new Date();
            var ms = now - this._current_time;
            if (ms > 100) {
                r += ms;
            }
        }
        return parseInt(r / 1000);
    }

    destroy() {
        if (this._stateInitialized) {
            this._stateInitialized = null;
            AppState.removeEventListener("change", this._handleAppStateChange);
        }
    }
}

export default ActiveTimeCost;
